import { Link } from "@tanstack/react-router";

import { Section } from "@/components/Section";
import { Container } from "@/components/Container";
import { Eyebrow } from "@/components/Eyebrow";
import { Reveal } from "@/components/Reveal";
import { NAP, SHOW_PHONE } from "@/lib/business";
import { Aurora } from "@/components/Aurora";
import { CtaButton } from "@/components/CtaButton";

export function FinalCta() {
  return (
    <Section tone="paper">
      <Container>
        <Reveal className="relative overflow-hidden rounded-3xl bg-ink-900 p-8 sm:p-12 lg:p-16">
          <Aurora variant="dark" />
          <div className="relative grid items-center gap-10 lg:grid-cols-[1fr_auto] lg:gap-16">
            <div className="max-w-[52ch]">
              <Eyebrow className="text-brand-300">Next step</Eyebrow>
              <h2
                className="mt-3 font-display text-h2 text-paper-0"
                style={{ textWrap: "balance" }}
              >
                Tell us where the work is piling up.
              </h2>
              <p className="mt-4 text-body-lg text-ondark-body">
                Twenty minutes, no cost, no pitch. You&rsquo;ll leave knowing whether AI helps your
                business — including if the answer is no.
              </p>
            </div>

            <div className="flex flex-col items-start gap-4 lg:items-center">
              <CtaButton asChild tone="dark">
                <Link to="/book">Book a Free AI Call</Link>
              </CtaButton>
              {SHOW_PHONE ? (
                <a
                  href={NAP.phoneHref}
                  className="inline-flex min-h-[44px] items-center rounded-sm font-mono text-body-sm text-ondark-muted underline-offset-4 transition-brand hover:text-paper-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 focus-visible:ring-offset-2 focus-visible:ring-offset-ink-900"
                >
                  Or call {NAP.phone}
                </a>
              ) : null}
            </div>
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}

export default FinalCta;
